package net.zagart.ai.core.feature.story

import net.zagart.ai.core.feature.story.prompt.StoryPrompts

data class StoryConfig(
    val model: String = "deepseek-chat",
    val genre: String = "fantasy",
    val language: String = "english",
    val plotWishes: String = "",
    val systemPrompt: String = StoryPrompts.defaultSystemPrompt,
    val temperature: Float = 0.8f,
    val maxHistoryTokens: Int = 4096
)
